export const scoreboardLaunchUrl = (baseUrl, matchId, organizationId, launchId) => {
  const url = new URL(`/league/${encodeURIComponent(matchId)}`, `${baseUrl.replace(/\/$/, "")}/`);
  if (organizationId) url.searchParams.set("organizationId", organizationId);
  if (launchId) url.searchParams.set("launch", launchId);
  return url.toString();
};

export const scoreboardStatusLabel = (game) => {
  if (game.status === "Available") return "Available";
  if (game.status === "Reserved") return "Claimed · waiting for first turn";
  if (game.status === "InProgress") return "Live now";
  if (game.status === "ReconnectRequired") return "Board needs to reconnect";
  if (game.status === "Complete") return "Complete";
  return game.unavailableReason || game.status;
};

export const matchLiveCopy = (live, memberIsHome) => {
  if (!live) return null;
  const memberWins = memberIsHome ? live.homeWins : live.awayWins;
  const opponentWins = memberIsHome ? live.awayWins : live.homeWins;
  const active = live.activeGameNumbers || [];
  const activeText = active.length
    ? `Game${active.length === 1 ? "" : "s"} ${active.join(" and ")} ${active.length === 1 ? "is" : "are"} active`
    : live.status === "Complete"
      ? "Match scoring is complete"
      : live.status === "Loading"
        ? "Updating match progress…"
        : live.status === "Offline"
          ? "Connect to update match progress"
          : live.status === "Unavailable"
            ? "Match progress is temporarily unavailable"
      : live.status === "Paused"
        ? "No board is active right now"
        : "No game has started yet";
  const nextNumber = live.viewerNextGameNumber;
  const nextIsActive = nextNumber != null && active.includes(nextNumber);
  const gamesUntil = nextNumber == null
    ? 0
    : (live.games || []).filter((game) =>
        game.gameNumber <= nextNumber && game.status !== "Complete" && game.status !== "Active").length;
  const nextTiming = nextNumber == null
    ? live.status === "Loading" ? "Checking your next game"
      : live.status === "Offline" ? "Your next game will update when connected"
        : live.status === "Unavailable" ? "We’ll keep trying automatically"
          : live.status === "Complete" ? "Your scheduled games are complete" : "No remaining game assignment"
    : nextIsActive
      ? "You are playing now"
      : gamesUntil <= 1 ? "You are up next" : `You are up in ${gamesUntil} games`;
  return { memberWins, opponentWins, activeText, nextTiming };
};
